module.exports = {
  returnNameFormatted: {
    1: 'Inclusão',
    2: 'Alteração',
    3: 'Exclusão',
    4: 'Transferência',
  },
  returnName: {
    1: 'Inclusao',
    2: 'Alteracao',
    3: 'Exclusao',
    4: 'Transferencia',
    5: 'Lote',
    6: 'Nestle',
    7: 'Lote-csv',
  },
  returnIdForNameFormatted: {
    Inclusão: 1,
    Alteração: 2,
    Exclusão: 3,
    Transferência: 5,
    Inativos: 6,
  },
  returnIdForName: {
    Inclusao: 1,
    Alteracao: 2,
    Exclusao: 3,
    Transferencia: 4,
    Lote: 5,
    Nestle: 6,
    'Lote-csv': 7,
  },
};
